<template>
  <div class="row row-space-2">
    <!-- begin widget-chart -->
    <div
      class="widget widget-rounded m-b-30"
      v-bind:class="{ 'inverse-mode': inverseMode }"
    >
      <!-- begin widget-header -->
      <div class="widget-header">
        <h4 class="widget-header-title ts-flex ts-justify-between">
          <div
            class="ts-flexts-justify-content-start"
            :class="{ 'ts-text-gray-700': !inverseMode }"
          >
            <strong>
              {{ $t('dashboardcomponents.totalIncomeUnpaidStudent') }}</strong
            >
          </div>
          <div class="ts-flex ts-justify-content-end ts-justify-item-center">
            <select
              v-model="selectedFilter"
              @change="fetchData"
              class="filter mr-2"
              :class="{ 'filter-dark': inverseMode }"
            >
              <option
                v-for="(filter, filterKey) in filters"
                :value="filterKey"
                :key="filterKey"
              >
                {{ filter }}
              </option>
            </select>
          </div>
        </h4>
      </div>
      <!-- end widget-header -->
      <!-- begin vertical-box -->
      <ts-loading-banner :loading="loading">
        <div class="vertical-box with-grid with-border-top">
          <!-- begin vertical-box-column -->
          <div class="vertical-box-column p-4" style="width: 60%">
            <p>
              {{
                $t(
                  'dashboardcomponents.abarchartshowthestatisticsoftheincomeamountbasedontheselectedcategory'
                )
              }}
            </p>
            <bar-chart
              :data="{
                labels: incomeByFeeLabels,
                datasets: incomeByFeeDatasets
              }"
              :options="options"
              class="height-sm"
            ></bar-chart>
          </div>
          <!-- end vertical-box-column -->
          <!-- begin vertical-box-column -->
          <div class="vertical-box-column widget-chart-content">
            <div class="nv-stacked-area-chart height-full">
              <p>
                {{
                  $t(
                    'dashboardcomponents.abarchartshowthestatisticsoftheamountoftheamountofunpaidstudentsbasedontheselectedcategory'
                  )
                }}
              </p>
              <bar-chart
                :data="{
                  labels: unpaidStudentLabels,
                  datasets: unpaidStudentDatasets
                }"
                :options="options"
                class="height-sm"
              ></bar-chart>
            </div>
          </div>
          <!-- end vertical-box-column -->
        </div>
      </ts-loading-banner>
      <!-- end vertical-box -->
    </div>
    <!-- end widget-chart -->
  </div>
</template>
<script>
import BarChart from '@/components/vue-chartjs/BarChart'
import { map, keys } from 'lodash'
export default {
  components: {
    BarChart
  },
  props: ['inverseMode'],
  data() {
    return {
      filters: {
        fee_description: 'Fee',
        class_name: 'Class',
        grade_name_foreign: 'Grade',
        level_abbr: 'Level',
        term_name: 'Term',
        acps_abbr: 'Sub Progam',
        acp_abbr: 'Academic Progam'
      },
      loading: false,
      selectedFilter: '',
      unpaidStudent: [],
      incomeByFee: [],
      options: {
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  computed: {
    incomeByFeeLabels() {
      return keys(this.incomeByFee)
    },
    incomeByFeeDatasets() {
      return [
        {
          label: 'Amount (VAT Included)',
          borderColor: '#49b6d6',
          backgroundColor: 'rgba(73, 182, 214, 0.7)',
          borderWidth: 2,
          data: map(this.incomeByFee, r => {
            return r
          })
        }
      ]
    },
    unpaidStudentLabels() {
      return keys(this.unpaidStudent)
    },
    unpaidStudentDatasets() {
      return [
        {
          label: 'Amount (VAT Included)',
          borderColor: '#ff5b57',
          backgroundColor: 'rgba(255, 91, 87, 0.7)',
          borderWidth: 2,
          data: map(this.unpaidStudent, r => {
            return r
          })
        }
      ]
    }
  },
  mounted() {
    this.selectedFilter = Object.keys(this.filters)[0]

    this.fetchDataTotalUnpaid()
    this.fetchDataIncomeByFee()
  },
  methods: {
    fetchData() {
      this.fetchDataTotalUnpaid()
      this.fetchDataIncomeByFee()
    },
    fetchDataTotalUnpaid() {
      this.loading = true
      this.$store
        .dispatch('dashboard/fetchUnpaidStudent', {
          group_by: this.selectedFilter
        })
        .then(responses => {
          this.unpaidStudent = responses
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    fetchDataIncomeByFee() {
      this.loading = true
      this.$store
        .dispatch('dashboard/fetchIncomeByFee', {
          group_by: this.selectedFilter
        })
        .then(responses => {
          this.incomeByFee = responses
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style scoped>
.filter {
  color: #707478;
  border: 1px solid #d3d8de;
  -webkit-box-shadow: none;
  box-shadow: none;
  height: 35px;
  padding: 0.3125rem 0.625rem;
  font-size: 0.75rem;
  line-height: 1.4;
  border-radius: 3px;
}
.filter-dark {
  background-color: #242a30;
  color: white;
  border: 1px solid #1a1e22;
}
.widget-header-title,
.widget-header-icon {
  padding: 5px 10px !important;
}
</style>
